module.exports = __webpack_public_path__ + "img/fm-Path 39 Copy@3x.c4c841b0.png";